import React from "react"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import styles from "./styles"

const colorSelector = (color, classes) => ({
    primary: classes.primary,
    resetPassword: classes.resetPassword,
}[color])

const LoginBg = ({ color,currentCompany, classes }) => (
    <div className={classes.background}>
    {currentCompany === "arkin" && <div className={classes.overlay}></div>}
        <div
            className={colorSelector(color, classes)}
        />
        <div
        className={classes.image}
        style={{
            filter: currentCompany === "allianzpartners" || currentCompany === "allianzgi" ? "contrast(.5) brightness(140%)" : "none",
        }}
        />
    </div>
)


LoginBg.propTypes = {
    color: PropTypes.oneOf(["primary", "resetPassword"]),
    classes: PropTypes.object.isRequired,
}

LoginBg.defaultProps = {
    color: "primary",
}

export default withStyles(styles)(LoginBg)
